<template>
	<Popup
		v-model="selfDisplay"
		title="新增类型"
		confirmBtnText="新增"
		@confirmClick="handleAddClick"
	>
		<div v-loading="loading" style="padding: 15px;">
			<div class="base_form_row">
				<span class="b_label"><span style="color: #f00;">*</span>类型名称</span>
				<el-input v-model="name" placeholder="类型名称"></el-input>
			</div>
			<div class="base_tip" style="padding: 0 0 0 120px;"><template v-if="nameTip"><i class="b_icon"></i>请输入类型名称</template></div>
			
			<div class="base_form_row">
				<span class="b_label"><span style="color: #f00;">*</span>序号</span>
				<el-input v-model="number" placeholder="序号"></el-input>
			</div>
			<div class="base_tip" style="padding: 0 0 0 120px;"><template v-if="numberTip"><i class="b_icon"></i>请输入合法序号</template></div>
		</div>
	</Popup>
</template>

<script>
	import Api from '../../../../../../../api/index.js';
	
	export default{
		model: {
			prop: 'display',
			event: 'changeDisplay'
		},
		props: {
			display: Boolean
		},
		mounted () {
			this.display && (this.selfDisplay = true);
		},
		data() {
			return{
				loading: false,
				selfDisplay: false,
				name: '',
				number: '',
				nameTip: false,
				numberTip: false
			}
		},
		methods: {
			// 点击新增
			handleAddClick() {
				if (!this.name.trim()) {
					this.nameTip = true;
					return false;
				} else {
					this.nameTip = false;
				}
				if (!this.positiveReg.test(this.number)) {
					this.numberTip = true;
					return false;
				} else {
					this.numberTip = false;
				}
				this.add();
			},
			add() {
				const that = this;
				that.loading = true;
				let requestData = {
					catName: that.name,
					orderNo: that.number
				};
				Api.addAppArticleType(requestData).then((res) => {
					if (res.data.success) {
						that.loading = false;
						that.$message.success(res.data.message);
						that.selfDisplay = false;
						that.$emit('onSuccess');
					} else {
						that.loading = false;
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			}
		},
		watch: {
			display(newVal) {
				this.selfDisplay = newVal;
			},
			selfDisplay(newVal) {
				this.$emit("changeDisplay", newVal);
				if (!newVal) {
					this.loading = false;
					this.name = '';
					this.number = '';
					this.nameTip = false;
					this.numberTip = false;
				}
			}
		}
	}
</script>

<style>
</style>
